import type { Step } from "react-joyride";

export const qcTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການມາດຕະຖານ QC! ມາດຕະຖານ QC (Quality Control Standard) ແມ່ນລະບຽບການກວດຄຸນນະພາບທີ່ຊ່ວຍກຳນົດວິທີການກວດສອບສຳລັບການດຳເນີນງານ. ທ່ານສາມາດສ້າງມາດຕະຖານ QC ສຳລັບການກວດສອບຄຸນນະພາບ, ການປະເມີນຜົນການດຳເນີນງານ, ຫຼືການຕິດຕາມຄຸນນະພາບ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="qc-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງມາດຕະຖານ QC ໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງມາດຕະຖານ QC ທີ່ທ່ານຕ້ອງການ. ມາດຕະຖານ QC ຈະຊ່ວຍທ່ານກຳນົດລະບຽບການກວດສອບຄຸນນະພາບສຳລັບການດຳເນີນງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="qc-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາມາດຕະຖານ QC ຕາມຊື່, ປະເພດງານ, ພະແນກ, ຫຼືສະຖານະ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="qc-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງມາດຕະຖານ QC ທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຄັດລອກ, ເປີດ/ປິດການໃຊ້ງານ, ຫຼືລຶບມາດຕະຖານ QC ໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະມາດຕະຖານ QC. ທ່ານຍັງສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງມາດຕະຖານ QC ແຕ່ລະຕົວ, ຫຼືກົດເພື່ອບັນທຶກຜົນກວດ QC.",
    placement: "top",
  },
];
